/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from 'axios'

/*
 * Dedicated axios instance: no shared interceptors, so a failing /health
 * never triggers the global 401/403/404 redirects.
 */
const client = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL,
    timeout: 5000
})

export function fetchSystemHealth() {
    return client.get('/api/health')
}
